<template>
  <div>
    <v-card>
      <v-card-title class="justify-center primary" icon @click="show = !show" style="cursor: pointer;">
          <v-toolbar-title id="titulocard">Tr&aacute;mites</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon :color="'#FFFFFF'">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-card-title>
      <v-expand-transition>
        <div v-if="show">
          <v-card-text>
            <div class="pt-5 px-4 pb-2">
              <v-row>
                <v-col cols="12" md="6" class="py-0">
                  <div v-for="(items, index) in tramitesOptions.filter(item => item.ttposicion == 1)" :key="index + 'a'">
                    <v-list-item>
                      <v-list-item-action>
                        <div>
                          <v-btn color="primary" fab small dark @click="tramitesTo(items)">
                            <v-icon>{{ items.ttricono }}</v-icon>
                          </v-btn>
                        </div>
                      </v-list-item-action>
                      <v-list-item-content>{{ items.ttrnombre }}</v-list-item-content>
                    </v-list-item>
                  </div>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <div v-for="(items, index) in tramitesOptions.filter(item => item.ttposicion == 2)" :key="index + 'b'">
                    <v-list-item>
                      <v-list-item-action>
                        <div>
                          <v-btn color="primary" fab small dark @click="tramitesTo(items)">
                            <v-icon>{{ items.ttricono }}</v-icon>
                          </v-btn>
                        </div>
                      </v-list-item-action>
                      <v-list-item-content>{{ items.ttrnombre }}</v-list-item-content>
                    </v-list-item>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>
<script>
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import ServTramites from "@/services/Tramites/Tramites.service.js";
export default {
  props: ["tramitesOptions"],
  data() {
    return {
      show: false,
      datos: {},
      reporte: {},
    };
  },
  async mounted() {
    let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
    this.reporte = datos;
    this.$emit("reload", true);
  },
  methods: {
    async tramitesTo(item) {
      let respuesta = await ServTramites.ValidacionesTramites(this.reporte);
      if (respuesta.Estatus == true) {
        if (respuesta.Respuesta == "") {
          var toToken = {
            cetipo: item.cetipo,
            tipomov: item.ttrnombre,
            showresp: item.ttrresp,
            reporte: this.reporte.nrreporte + '-' + this.reporte.svindice + '-' + this.reporte.aiclave + '-' + this.reporte.svfhconclusion
          };
          let token = MetodosGenerales.generateJsonToken(toToken);
          let currentRoute = this.$route.path;
          let currentRouteFormatted = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
          this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.reporte);
          this.$router.push({
            path: this.asistenciaurl + '/MovimientoTramite/' + token, params: {
              tokenData: token,
            },
          });
        } else {
          this.$swal({
            position: "center",
            icon: "warning",
            title: "Alerta",
            html: respuesta.Respuesta,
            confirmButtonText: "Aceptar",
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
      }
    },
  },
};
</script>

<style scoped>
.title-card-style {
  padding: 1.5px !important;
  max-height: auto;
}

.card-title-text {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 1em;
  color: white;
}

.collapsable-container {
  background-color: white;
}
</style>
